import React from 'react';
import './blog-post.css';
import './blog-slides.css';
import studyRoom from './pictures/studyRoom.jpeg';
import studyRoom2 from './pictures/studyRoom2.jpeg';

const SurvivorStudySesh = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header></header>
                <section>
                    <h2>Survivor Study Sesh</h2>
                    <p className="site-post-meta">December 2, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>Hi WiC Members!

                    <br></br>
                    <br></br>
                    Thank you for joining our Survivor Study Sesh event! We had a great turnout and learned a lot from each other and the wonderful TAs! We loved having all of you and seeing how amazingly locked in you guys were 📕🔒. A special congratulations to our “most locked in” winner, Nidhi, as well as everyone who stayed until the end! It was a relaxed evening for study, group problem solving, and catching up over snacks before finals kicked off.
                    <br></br>
                    <br></br>
                    We hope everyone found the session productive and enjoyed connecting with other WiC members. Big thank you to the numerous TAs who volunteered their time to help us out during their own busy finals week schedules, we would not have been able to do this without them!
                    <br></br>
                    <br></br>
                    </p>
                    <img src={studyRoom} alt="Attendees at the event in the room."/>
                    <img src={studyRoom2} alt="Attendees at the event in the room."/>

                </section>
                
            </div>
        </div>      
      </div>
    </div>
  );
};

export default SurvivorStudySesh;
